import { render, staticRenderFns } from "./orderDetailOld.vue?vue&type=template&id=48fea20b&scoped=true"
import script from "./orderDetailOld.vue?vue&type=script&lang=js"
export * from "./orderDetailOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fea20b",
  null
  
)

export default component.exports